import gql from 'graphql-tag';

const createLocallyLinkedDealerMutation = gql`
  mutation createLocallyLinkedDealer(
    $input: CreateLocallyLinkedDealerMutationInput!
  ) {
    createLocallyLinkedDealer(input: $input) {
      success
      errors
    }
  }
`;

export default createLocallyLinkedDealerMutation;
